import React from "react"
import PropTypes from "prop-types"
import { uniqueId } from "lodash"

import {
  StyledInputWrapper,
  StyledInput,
  StyledCheckValidation,
  StyledCrossValidation,
} from "./partials"

import { StyledFieldWrapper } from "./partials/StyledField"
import IconV2 from "../icon-v2"

const TextArea = ({
  id,
  placeholder,
  name,
  label,
  type,
  required,
  hidden,
  disable,
  value,
  onChange,
  isValid,
  isDark,
  loading,
}) => {
  const htmlId = uniqueId(id)

  const pattern = "^[^()/><{}~;]*$"
  const regex = new RegExp(pattern)

  return (
    <>
      <StyledFieldWrapper
        data-name="field-textarea"
        isDark={isDark}
        hidden={hidden}
        valid={isValid}
        loading={loading}
        empty={value.length < 1}
      >
        <div>
          {isValid && (
            <IconV2 icon={"check-circle"} size={"14"} iconType={"fas"} />
          )}
          {isValid === false && (
            <IconV2 icon={"exclamation-circle"} size={"14"} iconType={"fas"} />
          )}
          <textarea
            className={
              placeholder && placeholder.length > 0 ? "has_placeholder" : ""
            }
            id={htmlId}
            maxLength={950}
            name={name}
            placeholder={placeholder}
            required={required}
            disabled={disable}
            value={value}
            pattern={pattern}
            style={{
              width: "100%",
              minHeight: "150px",
              resize: "none",
            }}
            onChange={(e) => {
              if (id) {
                const { value, validity } = e.target

                onChange(id, {
                  value: value,
                  valid: validity.valid && regex.test(value),
                })
              } else onChange(e)
            }}
          />
          {label && <label htmlFor={htmlId}>{label}</label>}
        </div>
        {isValid === false &&
          (value.length > 0 ? (
            <span>Invalid data entry</span>
          ) : (
            <span>This is required</span>
          ))}
      </StyledFieldWrapper>
    </>
  )
}

TextArea.defaultProps = {
  id: "",
  className: "",
  name: "",
  placeholder: "",
  label: "",
  type: "textarea",
  hidden: false,
  required: false,
  disable: false,
  value: "",
  onChange: () => {},
  isValid: undefined,
  loading: false,
}

TextArea.propTypes = {
  id: PropTypes.string,
  className: PropTypes.string,
  name: PropTypes.string,
  placeholder: PropTypes.string,
  label: PropTypes.string,
  hide_label: PropTypes.bool,
  type: PropTypes.string,
  required: PropTypes.bool,
  disable: PropTypes.bool,
  hidden: PropTypes.bool,
  value: PropTypes.string,
  onChange: PropTypes.func,
  isValid: PropTypes.bool,
  loading: PropTypes.bool,
}

export default TextArea
